window.isNumberValidate = function(e) {
    var charCode = (e = e || window.event).which || e.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57 || charCode > 107 || charCode > 219 || charCode > 221) && charCode != 40 && charCode != 32 && charCode != 41 && (charCode < 43 || charCode > 46));
};

window.isAlfa = function(e) {
    var charCode = (e = e || window.event).which || e.keyCode;
    return !(charCode > 32 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122));
};

export function initContactForm() {
    const form = document.querySelector("#ContactForm");
    if (!form) return;

    // File change handler to show selected file name(s)
    const docInput = document.getElementById("document");
    if (docInput) {
        docInput.addEventListener("change", function() {
            const fileMsg = form.querySelector(".file-msg");
            if (!fileMsg) return;

            if (this.files.length === 0) {
                fileMsg.textContent = "No file chosen";
            } else if (this.files.length === 1) {
                fileMsg.textContent = this.files[0].name;
            } else {
                fileMsg.textContent = this.files.length + " files selected";
            }
        });
    }

    form.addEventListener("submit", async function(e) {
        e.preventDefault();

        let isValid = true;
        let invalidFileType = false;

        // Reset error styling and messages
        form.querySelectorAll(".form-group").forEach(group => {
            group.classList.remove("error-message");
        });
        form.querySelectorAll(".cfValidationMessage").forEach(msg => {
            msg.classList.add("displayNone");
        });

        const successMsg = form.querySelector(".contact-success-text");
        const errorMsg = form.querySelector(".contact-error-text");
        if (successMsg) successMsg.style.display = "none";
        if (errorMsg) errorMsg.style.display = "none";

        const oldToken = form.querySelector("#token-captcha");
        if (oldToken) oldToken.remove();

        // Validate text input fields
        form.querySelectorAll("input").forEach(input => {
            const val = input.value.trim();
            const id = input.id;
            const name = input.getAttribute("name");

            // Ignore hidden fields, file uploads, fields without names, or fields inside custom select libraries (SlimSelect)
            if (input.type === "hidden" || input.type === "file" || !name || input.closest("[class*='ss-']")) {
                return;
            }

            if (val === "" && id !== "phnumber_contact" && id !== "organization" && id !== "company_name" && id !== "technology" && id !== "document") {
                isValid = false;
                const group = input.closest(".form-group");
                if (group) {
                    group.classList.add("error-message");
                    const errSpan = group.querySelector(".cfValidationMessage");
                    if (errSpan) errSpan.classList.remove("displayNone");
                }
            }
        });

        // Validate textarea fields
        form.querySelectorAll("textarea").forEach(textarea => {
            const val = textarea.value.trim();
            if (val === "") {
                isValid = false;
                const group = textarea.closest(".form-group");
                if (group) {
                    group.classList.add("error-message");
                    const errSpan = group.querySelector(".cfValidationMessage");
                    if (errSpan) errSpan.classList.remove("displayNone");
                }
            }
        });

        // Validate email address
        const emailInput = form.querySelector("input#mail");
        if (emailInput) {
            const emailVal = emailInput.value.trim();
            const emailRegex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            const group = emailInput.closest(".form-group");
            
            if (emailVal === "") {
                isValid = false;
                if (group) {
                    group.classList.add("error-message");
                    const errSpan = group.querySelector(".cfValidationMessage");
                    if (errSpan) {
                        errSpan.textContent = "Please enter your Email Address";
                        errSpan.classList.remove("displayNone");
                    }
                }
            } else if (!emailRegex.test(emailVal)) {
                isValid = false;
                if (group) {
                    group.classList.add("error-message");
                    const errSpan = group.querySelector(".cfValidationMessage");
                    if (errSpan) {
                        errSpan.textContent = "Please enter valid Email Address";
                        errSpan.classList.remove("displayNone");
                    }
                }
            }
        }

        // Validate phone number
        const phoneInput = form.querySelector('input[name="Phone-Number"]');
        if (phoneInput) {
            const phoneVal = phoneInput.value.trim();
            const phoneRegex = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
            if (phoneVal !== "" && !phoneRegex.test(phoneVal)) {
                isValid = false;
                const group = phoneInput.closest(".form-group");
                if (group) {
                    group.classList.add("error-message");
                    const errSpan = group.querySelector(".cfValidationMessage");
                    if (errSpan) {
                        errSpan.textContent = "Please enter valid Phone Number";
                        errSpan.classList.remove("displayNone");
                    }
                }
            }
        }

        // Validate document uploads
        const docInput = document.getElementById("document");
        if (docInput && docInput.files.length > 0) {
            let totalSize = 0;
            const allowedMimeTypes = [
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.ms-powerpoint",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/zip",
                "application/x-zip-compressed",
                "application/pdf",
                "text/plain"
            ];
            const allowedExtensions = ["doc", "docx", "ppt", "pptx", "xls", "xlsx", "pdf", "zip", "txt"];

            for (let i = 0; i < docInput.files.length; i++) {
                const file = docInput.files[i];
                totalSize += file.size / 1024 / 1024;

                if (file.type !== "") {
                    if (!allowedMimeTypes.includes(file.type)) {
                        isValid = false;
                        invalidFileType = true;
                    }
                } else {
                    const extension = file.name.split(".").pop().toLowerCase();
                    if (!allowedExtensions.includes(extension)) {
                        isValid = false;
                        invalidFileType = true;
                    }
                }
            }

            const docGroup = docInput.closest(".form-group");
            if (totalSize > 10) {
                isValid = false;
                if (docGroup) {
                    docGroup.classList.add("error-message");
                    const errSpan = docGroup.querySelector(".cfValidationMessage.documentUploadError");
                    if (errSpan) errSpan.classList.remove("displayNone");
                }
            }

            if (invalidFileType) {
                isValid = false;
                if (docGroup) {
                    docGroup.classList.add("error-message");
                    const errSpan = docGroup.querySelector(".cfValidationMessage.typeInvalidError");
                    if (errSpan) errSpan.classList.remove("displayNone");
                }
            }
        }

        if (!isValid) {
            return false;
        }

        const isLocalEnvironment = () => {
            const host = window.location.hostname;
            return (
                host === "localhost" ||
                host === "127.0.0.1" ||
                /^192\.168\./.test(host) ||
                /^10\./.test(host) ||
                /^172\.(1[6-9]|2\d|3[0-1])\./.test(host)
            );
        };

        const submitForm = async () => {
            const loader = form.querySelector(".ajax-loader");
            if (loader) loader.classList.add("active");

                // Add this line temporarily to wait for 3 seconds:
            // await new Promise(resolve => setTimeout(resolve, 15000));

            const formData = new FormData(form);
            const actionUrl = form.getAttribute("action");

            try {
                const response = await fetch(actionUrl, {
                    method: "POST",
                    body: formData
                });
                const result = await response.json();

                if (result.success == 1) {
                    if (successMsg) successMsg.style.display = "block";
                    form.reset();
                    
                    form.querySelectorAll(".form-group").forEach(group => {
                        group.classList.remove("error-message");
                    });
                    if (docInput) docInput.value = "";
                    const fileMsg = form.querySelector(".file-msg");
                    if (fileMsg) fileMsg.textContent = "No file chosen";

                    const dropdown = document.getElementById("country-select");
                    if (dropdown) {
                        dropdown.value = "";
                        dropdown.dispatchEvent(new Event("change"));
                    }
                } else {
                    if (errorMsg) errorMsg.style.display = "block";
                }
            } catch (error) {
                console.error(error);
                if (errorMsg) errorMsg.style.display = "block";
            } finally {
                if (loader) loader.classList.remove("active");
            }
        };

        if (isLocalEnvironment()) {
            submitForm();
        } else {
            grecaptcha.ready(function() {
                grecaptcha.execute("6LdYKK4ZAAAAAJ7TVbzC3hj8sMgWqHxWphHB-2kV", {
                    action: "contact"
                }).then(function(token) {
                    const hidden = document.createElement("input");
                    hidden.type = "hidden";
                    hidden.name = "token";
                    hidden.id = "token-captcha";
                    hidden.value = token;
                    form.prepend(hidden);
                    submitForm();
                });
            });
        }
    });
}
